import { Injectable } from '@angular/core';
import { ConsumeCredencialesService } from '../generico/servicio/consume-credenciales.service';
import { MensajeService } from '../generico/servicio/mensaje.service';
import { SpinnerService } from '../spinner.service';
import { Aplicacion } from '../_models/aplicacion';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ModuloService {

  modulos : any = [];
  dialog_ref : any;
  aplicacion : Aplicacion;
  id_modulo : number ;
  index_update : number;

  constructor(
    private cred_serv: ConsumeCredencialesService,
    private msjserv : MensajeService,
    private spin : SpinnerService,
  ) { }

  public crear_modulo(data_form) {

    data_form["fk_aplicacion"] = this.aplicacion.id_aplicacion;

    this.cred_serv.post('aplicaciones/modulo', data_form)
        .subscribe(
          (data : any )=>{
            this.spin.spin$.next(false);
            let tipo_msg = this.msjserv.TIPO_OK;
            if(data.code ==0){
              this.modulos.push({"id_modulo_app" : data.data.id_modulo_app, "txt_descripcion" : data_form.txt_descripcion});
              
            }else{
              tipo_msg = this.msjserv.TIPO_ERROR;
            }
            
            this.msjserv.ver_mensaje(data.msg, '', tipo_msg)
                .afterClosed()
                .subscribe(()=>{
                  if(data.code == 0){
                    this.dialog_ref.close();
                  }

                });
          }
        );
  }

  public async consultar_modulos(id_aplicacion? : number){

    if (!id_aplicacion){
      id_aplicacion = this.aplicacion.id_aplicacion;
    }

    let http_parmas = new HttpParams().set('id_aplicacion', ''+id_aplicacion);
    const promise =  this.cred_serv.get('aplicaciones/modulo', http_parmas).toPromise();

    await promise.then(
      (data: any) =>{
        this.spin.spin$.next(false);
        this.modulos = data.data;
      }
    );

  }

  public actualizar_modulo(data_form){
    this.cred_serv.put('aplicaciones/modulo/'+this.id_modulo, data_form)
                  .subscribe((data : any)=>{

                    this.spin.spin$.next(false);
                    
                    let tipo_mensaje = this.msjserv.TIPO_OK;
                    if (data.code == 0){
                      this.modulos[this.index_update].txt_descripcion = data_form.txt_descripcion;
                    }else{
                      tipo_mensaje = this.msjserv.TIPO_ERROR
                    }

                    this.msjserv.ver_mensaje(data.msg, '', tipo_mensaje)
                        .afterClosed()
                        .subscribe(()=>{
                          if(data.code == 0){
                            this.dialog_ref.close();
                          }

                        });

                  });

  }
}
